import React from 'react';

const NotSupported = () => (
  <div className="pronounce">
        Sorry, your browser does not support speech synthesis or speech
    <a href="https://www.google.com/chrome" target="_blank" rel="noopener noreferrer">Google Chrome</a>.
  </div>
);

export default NotSupported;



// WEBPACK FOOTER //
// ./src/components/NotSupported.js